// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum ModifyCollaboratorOperation {
  None = 0,
  Added = 1,
  Removed = 2,
  AccessChanged = 3,
}
